import { gql } from '@apollo/client';

export const userGroupItem = gql`
  fragment userGroupItem on UserGroupConfig {
    id
    name
  }
`;
